// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2otgU","Wrapper":"Footer_Wrapper__FHjqH","Logo":"Footer_Logo__3Un7E"};